import { render, staticRenderFns } from "./DiscardModal.vue?vue&type=template&id=7761f47b&"
import script from "./DiscardModal.vue?vue&type=script&lang=ts&"
export * from "./DiscardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports